<h1 class="u-sr-only">{{ 'Profile.Menu.Surveys' | translate }}</h1>
<section class="c-section c-section--last u-no-pb" panel [isOpen]="true">
    <div class="c-section__header">
        <p class="c-section__title u-hidden@md-and-up">{{ 'Profile.Menu.Surveys' | translate }}</p>
    </div>
    <div class="c-section__content">
        <div class="o-grid">
            <div class="o-grid__cell c-cell">
                <div class="c-card c-card--s5">
                    <p class="c-text" style="font-size: 1.14em; margin: 15px 15px 8px 15px;">{{ 'Surveys.Survey_Description_1' | translate }}</p>
                    <p class="c-text" style="font-size: 1.14em; margin: 8px 15px;">{{ 'Surveys.Survey_Description_1_1' | translate }}</p>
                    <p class="c-text" style="font-size: 1.14em; margin: 8px 15px 15px 15px;">{{ 'Surveys.Survey_Description_2' | translate }}</p>
                </div>
                <p class="c-text c-text--main" style="font-size: 1.2em; margin: 25px 2px 15px 10px;">{{ 'Surveys.Survey_Subtitle' | translate }}</p>
                <div class="o-grid o-grid--wrap" style="margin: 0 -15px">
                    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up" *ngFor="let survey of vm.surveys">
                        <section class="c-section c-section--open c-section--static c-section--fit@md-and-up u-no-pb" panel>
                            <div class="c-section__content" style="margin-top: 15px;">
                                <div class="c-card c-card--height-fit">
                                    <div class="c-content u-no-pv u-ost-md u-osb-md">
                                        <p class="c-text c-text--bold c-text--main">{{ survey.translation.translationTextName }}</p>
                                        <p class="c-text" style="margin-top: 15px;">{{ survey.translation.translationTextDescription }}</p>
                                    </div>
                                    <div class="o-grid__cell o-grid__cell--w-fixed u-no-p o-grid__cell--right" style="margin: auto 15px 15px auto;">
                                        <a id="createSurveysButton" (click)="vm.openModalDialog(survey.codeName, survey.translation.translationTextName ? survey.translation.translationTextName : survey.description)" class="c-button c-button--s1 c-button--fit">{{ 'Surveys.Create_New_Survey' | translate }}</a>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
                <p class="c-text c-text--main" style="font-size: 1.2em; margin: 25px 2px 25px 2px;">{{ 'Surveys.History' | translate }}</p>
                <card-created-surveys></card-created-surveys>
            </div>
        </div>
    </div>
</section>